<template>
  <div class="header-container">
    <div class="header-bg">
      <div class="cover-bg"></div>
      <div class="header-main-containner">
        <div class="header-logo">
          <section class="layout-left">
            <img
              src="https://www.sjtu.edu.cn/resource/assets/img/LogoWhite@2x.png"
              alt=""
              srcset=""
              width="150"
            />
            <!-- <img :src="logo" alt="" srcset="" width="120">
                        <p>Shanghai Jiao Tong University</p> -->
          </section>
          <!-- <section class="layout-right">
                        <span class="lang-switch" @click="changeLang('zh-cn')">中文</span>&nbsp; | &nbsp;<span class="lang-switch" @click="changeLang('en-us')">English</span>
                    </section> -->
        </div>
        <div class="header-title">
          <h1>
            <span class="deep-blue-font">D</span>
            <span class="blue-font">I</span>
            <!-- <span class="black-font">RC</span> -->
            <span>RC 数据智能研究所</span>

            <!-- <span class="blue-font" style="font-size: 1.5em;">I</span> 
                        <span style="font-size: 1.5em;">IOT</span> -->
          </h1>
          <p class="sub-title">{{ $t(`header.subTitle`) }}</p>
        </div>
      </div>
    </div>
    <div class="header-menu">
      <div class="header-list">
        <li
          class="header-item"
          :class="{
            'active-style':
              $route.name === item.value ||
              (item.childList && item.childList.includes($route.name)),
          }"
          v-for="item in newHeaderList"
          :key="item.value"
        >
          <span v-if="!item.childList" @click="routerPush(item.value)">
            {{ $t(`header.${item.value}`) }}</span
          >
          <el-dropdown v-else trigger="click">
            <span class="el-dropdown-link">
              {{ $t(`header.${item.value}`)
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="header-dropdown">
              <el-dropdown-item
                v-for="child in item.childList"
                :key="child"
                @click.native="routerPush(child)"
                :class="{ 'active-style': $route.name === child }"
                >{{ $t(`header.${child}`) }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </li>
      </div>
    </div>
    <!-- <el-menu class="header-list" :default-active="activeIndex" mode="horizontal">
            <div class="header-item"  v-for="item in newHeaderList" :key="item.value" @click="clickEvent(item.value, $t(`header.${item.value}`))">
                <el-menu-item v-if="!item.childList" :index="item.value">{{ $t(`header.${item.value}`) }}</el-menu-item>
                <el-submenu v-else :index="item.value">
                    <template slot="title">{{ $t(`header.${item.value}`) }}</template>
                    <el-menu-item :index="child" v-for="child in item.childList" :key="child">{{ $t(`header.${child}`) }}</el-menu-item>
                </el-submenu>
            </div>
        </el-menu> -->
  </div>
</template>
<script>
import logo from "@/assets/image/logo.png";
export default {
  data() {
    return {
      newHeaderList: [
        {
          value: "home",
        },
        {
          value: "members",
          childList: ["faculty", "students", "alumni"],
        },
        {
          value: "project",
          childList: [
            "GeoScience",
            "acemap",
            "iiot",
            "ai",
            "socialscience",
            "security",
          ],
        },
        {
          value: "publication",
        },
        {
          value: "course",
        },
        {
          value: "photo",
          childList: ["academic", "spiritual", "life"],
        },
        {
          value: "talk",
        },
      ],
      logo,
    };
  },
  methods: {
    changeLang(lang) {
      console.log("lang", lang);
      // this.$i18n.locale = lang
      // this.$store.dispatch('toggleLang', lang)
    },
    routerPush(name) {
      this.$router.push({
        name,
      });
    },
  },
};
</script>
<style lang="less">
.header-container {
  .el-menu-item,
  .el-submenu__title {
    font-family: Source Han Sans SC, PingFang SC, Hiragino Sans GB,
      Microsoft YaHei, Arial, sans-serif;
    height: 64px;
    line-height: 64px;
    font-weight: 900;
    font-size: 16px;
    padding: 0 32px;
  }
  .el-menu-item:focus,
  .el-menu-item:hover,
  .el-submenu__title:hover {
    background: #ededed;
  }
  .el-menu-item.is-active {
    background: #ededed;
    color: #000;
  }
}
.header-dropdown {
  .el-dropdown-menu__item {
    color: #2c3e50;
  }
  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #ededed;
    color: #2c3e50;
  }
}
</style>
<style lang="less" scoped>
.header-container {
  .header-bg {
    position: relative;
    // height: 190px;
    height: 260px;
    // background: #4a4d50;
    // background: url(https://vs.sjtu.edu.cn/jtdx//resources/images/12756/0_b8024efc-32b6-410a-a2f0-95d01a249073.jpg);
    background: url(https://dirc.sjtu.edu.cn/api/v1/homepage/img?id=11);
    // background:
    // filter: grayscale(1);
    background-size: cover;
    background-position-y: -12px;
    color: #fff;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background: #000;
      opacity: 0.5;
    }
    .header-main-containner {
      position: relative;
      text-align: center;
      // width: 70%;
      // max-width: 1440px;
      // min-width: 740px;
      margin: auto;
    }
    .header-title {
      h1 {
        font-size: 50px;
        // font-size: 64px;
        font-weight: 900;
        margin-top: 24px;
      }
      .sub-title {
        // margin-top: 24px;
        font-size: 20px;
        font-weight: 900;
        margin-top: 24px;
      }
    }
    .header-logo {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 12px;
      .lang-switch {
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .blue-font {
        color: #00B0F0;
    }
  .deep-blue-font {
        color: #0370BF;
    }
  .black-font {
        color: #000;
    }

  .header-menu {
    background: #fff;
    border-bottom: solid 1px #dedede;
  }
  .header-list {
    height: 64px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-item {
      list-style: none;
      font-weight: 900;
      cursor: pointer;
      height: 64px;
      line-height: 64px;
      padding: 0 32px;
      display: inline-block;
      cursor: pointer;
      .el-dropdown {
        color: #2c3e50;
        font-size: 16px;
        font-weight: 900;
      }
      /* 针对最大宽度为980像素的设备 */
      @media screen and (max-width: 1440px) {
        font-size: 16px;
        padding: 0 32px;
        .el-dropdown {
            font-size: 16px;
        }
      }
      /* 针对最大宽度为1100像素的设备 */
      @media screen and (max-width: 1100px) {
        font-size: 16px;
        padding: 0 16px;
        .el-dropdown {
            font-size: 16px;
        }
      }
      /* 针对最大宽度为768像素的设备 */
      @media screen and (max-width: 768px) {
        font-size: 14px;
        padding: 0 16px;
        .el-dropdown {
            font-size: 14px;
        }
      }
      /* 针对最大宽度为580像素的设备 */
      @media screen and (max-width: 580px) {
        font-size: 12px;
        padding: 0 6px;
        .el-dropdown {
            font-size: 12px;
        }
      }

      /* 针对最大宽度为480像素的设备 */
      @media screen and (max-width: 480px) {
        font-size: 12px;
        padding: 0;
        .el-dropdown {
            font-size: 12px;
        }
      }
    }
  }
}
.active-style {
  background: #ededed;
}
</style>